/* Meowtside: header shadow, product variant/bundle/gallery, sticky add to cart */
(function () {
  var header = document.querySelector('.mt-header');
  var scroller = document.querySelector('.page-wrapper');
  if (header) {
    var onScroll = function () {
      var y = Math.max(window.scrollY || 0, scroller ? scroller.scrollTop : 0);
      header.classList.toggle('is-stuck', y > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    if (scroller) scroller.addEventListener('scroll', onScroll, { passive: true });
  }
  function formatMoney(cents, format) {
    format = format || '${{amount}}';
    var value = (Number(cents) || 0) / 100;
    function d(n, dec, th, sep) {
      var p = n.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p.length > 1 ? p[0] + sep + p[1] : p[0];
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return d(value, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return d(value, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return d(value, 0, '.', ',');
      return d(value, 2, ',', '.');
    });
  }
  document.querySelectorAll('[data-mt-product]').forEach(function (root) {
    var fmt = root.getAttribute('data-money-format');
    var priceEl = root.querySelector('[data-mt-price]');
    var compareEl = root.querySelector('[data-mt-compare]');
    var labelEl = root.querySelector('[data-mt-variant-label]');
    var qtyEl = root.querySelector('[data-mt-qty]');
    var atc = root.querySelector('[data-mt-atc]');
    var track = root.querySelector('[data-mt-track]');
    var thumbs = root.querySelectorAll('[data-mt-thumb]');
    var sticky = document.querySelector('[data-mt-sticky="' + root.id + '"]');
    var atcLabel = atc ? atc.getAttribute('data-label') : '';
    function current() { return root.querySelector('input[name="id"]:checked') || root.querySelector('input[name="id"]'); }
    function qty() { var b = root.querySelector('input[name="mt_bundle"]:checked'); return b ? Number(b.value) : 1; }
    function goToMedia(id) {
      if (!track) return;
      var s = track.querySelector('[data-media-id="' + id + '"]');
      if (s) track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    function update(fromVariant) {
      var v = current();
      if (!v) return;
      var price = Number(v.getAttribute('data-price'));
      var compare = Number(v.getAttribute('data-compare'));
      var q = qty();
      if (qtyEl) qtyEl.value = q;
      if (priceEl) priceEl.textContent = formatMoney(price * q, fmt);
      if (compareEl) {
        if (compare > price) { compareEl.textContent = formatMoney(compare * q, fmt); compareEl.hidden = false; }
        else { compareEl.hidden = true; }
      }
      root.querySelectorAll('[data-mt-bundle-price]').forEach(function (el) {
        el.textContent = formatMoney(price * Number(el.getAttribute('data-qty')), fmt);
      });
      if (labelEl && v.getAttribute('data-title')) labelEl.textContent = v.getAttribute('data-title');
      var available = v.type === 'hidden' || v.getAttribute('data-available') === 'true';
      if (atc) { atc.disabled = !available; atc.textContent = available ? atcLabel : 'Sold out'; }
      if (sticky) {
        var sp = sticky.querySelector('[data-mt-sticky-price]');
        var sv = sticky.querySelector('[data-mt-sticky-variant]');
        var sb = sticky.querySelector('button');
        if (sp) sp.textContent = formatMoney(price * q, fmt);
        if (sv && v.getAttribute('data-title')) sv.textContent = v.getAttribute('data-title');
        if (sb) sb.disabled = !available;
      }
      if (fromVariant) {
        if (v.getAttribute('data-media')) goToMedia(v.getAttribute('data-media'));
        if (window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.value);
          window.history.replaceState({}, '', url.toString());
        }
      }
    }
    root.addEventListener('change', function (e) {
      if (e.target.name === 'id') update(true);
      if (e.target.name === 'mt_bundle') update(false);
    });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goToMedia(t.getAttribute('data-mt-thumb')); });
    });
    if (track && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var id = en.target.getAttribute('data-media-id');
          thumbs.forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-mt-thumb') === id ? 'true' : 'false'); });
        });
      }, { root: track, threshold: 0.6 });
      track.querySelectorAll('[data-media-id]').forEach(function (s) { io.observe(s); });
    }
    if (sticky && atc && 'IntersectionObserver' in window) {
      var so = new IntersectionObserver(function (entries) {
        var en = entries[0];
        var show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        var b = sticky.querySelector('button');
        if (b) b.tabIndex = show ? 0 : -1;
      });
      so.observe(atc);
    }
    update(false);
  });
})();